import { joinClasses } from '../../primitives/fieldClassSlots';
import { layoutInlineStyle } from '../layoutInlineStyle';
import type { LayoutNodeChildProps } from '../nodeRenderProps';
import type { GridNode } from '../types';
import { RenderNodes } from '../renderNodes';

export function Grid({
  node,
  answers,
  repeatBindings,
}: LayoutNodeChildProps<GridNode>) {
  const GRID_VARIANT_ROW_GAP: Record<'compact' | 'default' | 'loose', number> =
    {
      compact: 4,
      default: 6,
      loose: 8,
    };
  const GRID_VARIANT_COLUMN_GAP: Record<
    'compact' | 'default' | 'loose',
    string
  > = {
    compact: 'gap-x-6',
    default: 'gap-x-8',
    loose: 'gap-x-10',
  };
  const variant = node.variant ?? 'default';
  const rowGap = node.gap ?? GRID_VARIANT_ROW_GAP[variant];
  const gapClass =
    node.cols >= 2
      ? joinClasses(GRID_VARIANT_COLUMN_GAP[variant], `gap-y-${rowGap}`)
      : `gap-${rowGap}`;
  return (
    <div
      className={[
        // Single column below `md` so bespoke grids stack on mobile
        `grid grid-cols-1 md:grid-cols-${node.cols} ${gapClass} [&>*]:min-w-0`,
        node.className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={layoutInlineStyle(node.style)}
    >
      <RenderNodes
        nodes={node.children}
        answers={answers}
        repeatBindings={repeatBindings}
      />
    </div>
  );
}
